import React from 'react';
export function VisualizationSection() {
  return <section className="relative w-full bg-gradient-to-br from-[#0D0D0D] via-[#1C1C1C] to-[#0D0D0D] py-16 md:py-32 px-4 md:px-6 overflow-hidden" data-id="element-227">
      {/* Parallax effect background */}
      <div className="absolute inset-0 opacity-10" data-id="element-228">
        <div className="absolute top-20 left-10 w-48 md:w-64 h-48 md:h-64 bg-[#D4AF37] blur-3xl rounded-full" data-id="element-229"></div>
        <div className="absolute bottom-20 right-10 w-64 md:w-96 h-64 md:h-96 bg-[#FF4F75] blur-3xl rounded-full" data-id="element-230"></div>
      </div>
      <div className="relative max-w-5xl mx-auto text-center" data-id="element-231">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-6xl font-bold text-white mb-8 md:mb-12 leading-tight px-4" data-id="element-232">
          Imagina tu <span className="text-[#D4AF37]" data-id="element-233">Nueva Realidad</span>
        </h2>
        <div className="bg-gradient-to-br from-[#1C1C1C] to-[#0D0D0D] p-8 md:p-16 rounded-2xl md:rounded-3xl border border-[#D4AF37]/30 shadow-2xl" data-id="element-234">
          <p className="font-['Inter'] text-lg md:text-3xl text-gray-200 leading-relaxed mb-6 md:mb-8" data-id="element-235">
            Imagina abrir tu laptop desde cualquier lugar del mundo...
          </p>
          <p className="font-['Inter'] text-lg md:text-3xl text-gray-200 leading-relaxed mb-6 md:mb-8" data-id="element-236">
            Ver notificaciones de{' '}
            <span className="text-[#FF4F75] font-bold" data-id="element-237">
              resultados extraordinarios
            </span>
          </p>
          <p className="font-['Inter'] text-lg md:text-3xl text-gray-200 leading-relaxed mb-6 md:mb-8" data-id="element-238">
            Sin jefes. Sin horarios. Sin límites.
          </p>
          <p className="font-['Inter'] text-base md:text-xl text-[#D4AF37] italic mt-8 md:mt-12" data-id="element-239">
            Esta es la vida que construyen nuestros closers certificados.
          </p>
        </div>
      </div>
    </section>;
}